<template>
  <div class="app-download">
    <img src="../assets/images/open_imgs.png" v-if="weChat" alt="" class="open">
    <img src="../assets/images/app_bg.png" alt="" class="open">
    <div class="app-list">
      <!-- <div :class="['app-item',val.class]" :key="key" v-for="(val,key) in appList" @click="toApp(key)">{{val.name}}</div> -->
      <img src="../assets/images/load_s.png" @click="toApp(0)">
    </div>
  </div>
</template>

<script>
  import Http from "../lib/Http";

  export default {
    data() {
      return {
        // androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.0.0.apk'
        // androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.0.1.apk'
        appList:[
          {name:'学生端下载',class:'app-student'}
        ],
        appUrl:[
          {
            iosUrl:'https://itunes.apple.com/cn/app/%E6%85%A7%E5%AD%A6%E5%AE%9D%E5%AD%A6%E7%94%9F%E7%AB%AF/id1442487562?mt=8',
            androidUrl:'http://fastcvf.zhixinhuixue.com/apk/zxhx_student_1.3.8.apk',
          }
        ],
        weChat:false,
      }
    },
    methods: {
      isPC() {
        const userAgentInfo = navigator.userAgent;
        const Agents = ["Android", "iPhone", "Windows Phone", "iPad", "iPod"];
        let flag = true;
        for (let v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      isWeChat(){
        let ua = navigator.userAgent.toLowerCase();
        if(ua.indexOf("micromessenger") != -1 ||  ua.indexOf("qq/") != -1) {
          this.weChat = true;
        } else{
          this.weChat = false;
        }
      },
      toApp(key){
        const ua = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(ua)) {
            window.location.href = this.appUrl[key].iosUrl;
        } else if (/android/.test(ua)) {
          // window.location.href = this.appUrl[key].androidUrl;
          let softwareId = key===1?7:5
          Http.Axios.get(`${Http.SIGN_NAME_API_ROOT()}cms/api/software/latest/${softwareId}`, {}).then(function (res) {
            // console.log(res)
            window.location.href = res.data.data.fileUrl
          }).catch(function (err) {

          });
        }
      }
    },
    mounted(){
      this.isWeChat();
      // window.location.reload();
    }
  }
</script>

<style scoped>
.app-download{
  position:relative;
  height: 100vh;
  background: #fcfffe;
  /* background:url(../assets/images/app_bg.png) no-repeat left center; */
  background-size: 100%;
}
.open{
  width: 100%;
}
.app-list{
  position: absolute;
  left:50%;
  bottom:6%;
  transform:translateX(-50%);
  -webkit-transform: translateX(-50%);
  font-size:16px;
  width: 56%;
}
.app-list img{
  margin-bottom:30px;
  width:100%;
}
.app-item{
  margin-bottom:30px;
  line-height: 36px;
  text-align: center;
  border:2px solid #A0DA58;
  border-radius: 20px;
  background: #A0DA58;
  color: #fff;
  box-sizing: border-box;
}
/* .app-teacher{border: 2px solid #89693C;} */
.app-student{
  margin-bottom: 60px;
  border: 2px solid #89693C;
  color: #89693C;
  background: none;
}
</style>



// WEBPACK FOOTER //
// AppStudentDownload.vue?4325240d